import { FC } from "react";
import {
  TLearnerReportFilterForm,
  defaultLearnerReportFilterValues,
  isEmptyLearnerReportFilterValue,
} from "@/features/learning-progress/utils/learner-report-filter-shared";
import { learnerReportFilterSchema } from "@/features/learning-progress/schema/learnerReportFilterSchema";
import { LearnerReportFilterFormFields } from "@/features/learning-progress/components/report/LearnerReportFilterFormFields";
import { FilterPopover } from "@/features/learning-progress/components/report/FilterPopover";

type Props = {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onApplyFilters?: (filters: TLearnerReportFilterForm) => void;
  initialFilters?: TLearnerReportFilterForm | null;
};

export const LearnerReportFilterModal: FC<Props> = ({ anchorEl, onClose, onApplyFilters, initialFilters }) => (
  <FilterPopover
    anchorEl={anchorEl}
    onClose={onClose}
    onApplyFilters={onApplyFilters}
    initialFilters={initialFilters}
    defaultValues={defaultLearnerReportFilterValues}
    schema={learnerReportFilterSchema}
    isEmptyValue={isEmptyLearnerReportFilterValue}
  >
    <LearnerReportFilterFormFields />
  </FilterPopover>
);
